import fr from './locales/fr.json'
import en from './locales/en.json'
import type { Locale } from '../locales'

/** Ressources de traduction partagées par le web, le mobile et les e-mails de l'API. */
export const resources = {
  fr: { translation: fr },
  en: { translation: en },
} as const satisfies Record<Locale, { translation: unknown }>

export type TranslationTree = typeof fr
